import { RootState } from 'redux/schemas';

export const getMentoringProgramEnrollment = (state: RootState, enrollmentId: number) => state.models.mentoringProgramEnrollments[enrollmentId];
